import React from "react";
import clsx from "clsx";

import type { BoxProps } from "@/ui/atoms/Box";
import Box from "@/ui/atoms/Box";

type TVariants =
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "body1"
    | "body2"
    | "body3"
    | "body4";

const variantToFontStylesMap: Record<TVariants, React.CSSProperties> = {
    h1: {
        fontFamily: "DM Sans",
        fontSize: "20px",
        lineHeight: "24px",
        fontWeight: 700,
        textAlign: "left",
        color: "var(--proda-black)",
    },
    h2: {
        fontFamily: "DM Sans",
        fontSize: "18px",
        lineHeight: "21px",
        fontWeight: 700,
        textAlign: "left",
        color: "var(--proda-black)",
    },
    h3: {
        fontFamily: "DM Sans",
        fontSize: "16px",
        lineHeight: "19px",
        fontWeight: 700,
        textAlign: "left",
        color: "var(--proda-black)",
    },
    h4: {
        fontFamily: "DM Sans",
        fontSize: "14px",
        lineHeight: "17px",
        fontWeight: 700,
        textAlign: "left",
        color: "var(--proda-black)",
    },
    h5: {
        fontFamily: "DM Sans",
        fontSize: "12px",
        lineHeight: "15px",
        fontWeight: 700,
        textAlign: "left",
        color: "var(--proda-black)",
    },
    body1: {
        fontFamily: "Noto Sans",
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: 400,
        textAlign: "left",
        color: "var(--proda-black)",
    },
    body2: {
        fontFamily: "Noto Sans",
        fontSize: "14px",
        lineHeight: "18px",
        fontWeight: 400,
        textAlign: "left",
        color: "var(--proda-black)",
    },
    body3: {
        fontFamily: "Noto Sans",
        fontSize: "12px",
        lineHeight: "15px",
        fontWeight: 400,
        textAlign: "left",
        color: "var(--proda-black)",
    },
    body4: {
        fontFamily: "Noto Sans",
        fontSize: "10px",
        lineHeight: "14px",
        fontWeight: 400,
        textAlign: "left",
        color: "var(--proda-black)",
    },
} as const;

export type TypographyProps = BoxProps & {
    variant: TVariants;
};

export const testId = "Typography";
const Typography = (props: TypographyProps) => {
    const { sx, children, className, variant, ...otherProps } = props;

    const variantStyles = variantToFontStylesMap[variant];

    return (
        <Box
            data-testid={testId}
            className={clsx([testId, className])}
            component={"span"}
            sx={{
                ...variantStyles,
                ...sx,
            }}
            {...otherProps}
        >
            {children}
        </Box>
    );
};

export default Typography;
